import type { AccountSource } from 'owa-graph-schema';
import { action } from 'satcheljs';

export default action('ADD_ACCOUNT', (accountSource: AccountSource) => ({
    accountSource,
}));
